import styled from "styled-components";

import typography from "../../theme/typography";

const StyledLongButton = styled.button`
  ${typography.buttonText1};
  background-color: ${(props) => props.theme.color.primary};
  color: ${(props) => props.theme.color.black};
  border: none;
  border-radius: 57px;
  cursor: pointer;
  width: ${(props) => props.width + "px"};
  height: 60px;
`;

const LongButton = ({ text, width, onClick }) => {
  return (
    <StyledLongButton width={width || 280} onClick={onClick}>
      {text}
    </StyledLongButton>
  );
};

export default LongButton;
